import { OPTION_VALUES_SERVER } from "./option-values";

export const BASIC_VARIANT_DETAILS_SERVER = `
  fragment BasicVariantDetails on Variant {
    id
    vendorByCountry:vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone)
    {
      externalId
    }
    hasTierPricing
    amountIn(currency: $currency)
    externalId
    images(storeNumber: $storeNumber)
    isMaster
    priceIn(currency: $currency)
    optionValues {
      ...OptionValuesDetails
    }
    weight
    measurementUnit
    productId
    minOrderableQuantity
    outOfStock
    prices(currency: $currency) {
      max
      min
      priceIn(currency: $currency)
      id
    }
  }
  ${OPTION_VALUES_SERVER}
`;
